import { el } from 'redom';

import ActivePollChoice from './active-poll-choice';

class PollChoice extends ActivePollChoice {

  constructor() {

    super();

    this.pollChoiceButtonEl = el('button.poll-choice-button');

    this.el = el('li.poll-choice-list-item', [this.pollChoiceButtonEl]);

  }

  update(choice, index, choices, context) {

    this.pollChoiceButtonEl.textContent = choice.name;

    this.pollChoiceButtonEl.addEventListener('click', this.handleChoiceButtonClick.bind(this, index, choice, context.poll));

  }

}

export default PollChoice;